import { render } from "./modalTerms.vue?vue&type=template&id=2b04c297"
import script from "./modalTerms.vue?vue&type=script&lang=js"
export * from "./modalTerms.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__